/**
 * Standalone skeleton loading grid for product cards.
 * Extracted from ProductGrid's internal loading state so it can be rendered
 * independently without ProductGrid's fetch/state machinery.
 */

import { ProductCardSkeleton } from "./ProductCardSkeleton";

export function ProductGridSkeleton() {
  const skeletonCount = 8;
  const skeletons = Array.from({ length: skeletonCount }, (_, i) => i);

  return (
    <div className="w-full overflow-hidden">
      {/* Up to extra-large screens (<1280px) – 2 columns */}
      <div className="flex w-full gap-3 xl:hidden">
        {[0, 1].map((colIndex) => (
          <div key={`skeleton-col-2-${colIndex}`} className="min-w-0 flex-1 space-y-3">
            {skeletons
              .filter((_, i) => i % 2 === colIndex)
              .map((i) => (
                <ProductCardSkeleton key={`skeleton-2col-${i}`} />
              ))}
          </div>
        ))}
      </div>

      {/* Extra-large screens (1280px–1535px) – 3 columns */}
      <div className="hidden w-full gap-3 xl:flex 2xl:hidden">
        {[0, 1, 2].map((colIndex) => (
          <div key={`skeleton-col-3-${colIndex}`} className="min-w-0 flex-1 space-y-3">
            {skeletons
              .filter((_, i) => i % 3 === colIndex)
              .map((i) => (
                <ProductCardSkeleton key={`skeleton-3col-${i}`} />
              ))}
          </div>
        ))}
      </div>

      {/* 2XL screens (1536px–1919px) – 4 columns */}
      <div className="hidden w-full gap-3 2xl:flex 3xl:hidden">
        {[0, 1, 2, 3].map((colIndex) => (
          <div key={`skeleton-col-4-${colIndex}`} className="min-w-0 flex-1 space-y-3">
            {skeletons
              .filter((_, i) => i % 4 === colIndex)
              .map((i) => (
                <ProductCardSkeleton key={`skeleton-4col-${i}`} />
              ))}
          </div>
        ))}
      </div>

      {/* 3XL screens (≥1920px) – 5 columns */}
      <div className="hidden w-full gap-3 3xl:flex">
        {[0, 1, 2, 3, 4].map((colIndex) => (
          <div key={`skeleton-col-5-${colIndex}`} className="min-w-0 flex-1 space-y-3">
            {skeletons
              .filter((_, i) => i % 5 === colIndex)
              .map((i) => (
                <ProductCardSkeleton key={`skeleton-5col-${i}`} />
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}
